import { MailContact } from "@packages/chat-sdk";
import { Store } from "./store";
export interface MailContactsStoreType {
  selectedContactOrRoom?: MailContact;
}

export const mailContactsStore = new Store<MailContactsStoreType>(() => ({
  selectedContactOrRoom: undefined,
}));
export const mailContactsStoreActions = {
  setSelectedContactOrRoom(payload?: MailContact) {
    mailContactsStore.set({
      selectedContactOrRoom: payload,
    });
  },
};
